const FormateNumber = ({ number }) => {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'KES',
    maximumFractionDigits: 2,
  }).format(number);
};
export default FormateNumber;
